import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40e73d4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width"]
const _hoisted_2 = ["rowspan", "colspan"]
const _hoisted_3 = ["innerHTML"]

import { computed, PropType, ref, watch } from 'vue'
import { PPTElementOutline, TableCell, TableTheme } from '@/types/slides'
import { getTextStyle, formatText } from './utils'
import useHideCells from './useHideCells'
import useSubThemeColor from './useSubThemeColor'


export default /*#__PURE__*/_defineComponent({
  __name: 'StaticTable',
  props: {
  data: {
    type: Array as PropType<TableCell[][]>,
    required: true,
  },
  width: {
    type: Number,
    required: true,
  },
  cellMinHeight: {
    type: Number,
    required: true,
  },
  colWidths: {
    type: Array as PropType<number[]>,
    required: true,
  },
  outline: {
    type: Object as PropType<PPTElementOutline>,
    required: true,
  },
  theme: {
    type: Object as PropType<TableTheme>,
  },
  editable: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props



const colSizeList = ref<number[]>([])
const totalWidth = computed(() => colSizeList.value.reduce((a, b) => a + b))

watch([
  () => props.colWidths,
  () => props.width,
], () => {
  colSizeList.value = props.colWidths.map(item => item * props.width)
}, { immediate: true })

const cells = computed(() => props.data)
const { hideCells } = useHideCells(cells)

const theme = computed(() => props.theme)
const { subThemeColor } = useSubThemeColor(theme)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "static-table",
    style: _normalizeStyle({ width: _unref(totalWidth) + 'px' })
  }, [
    _createElementVNode("table", {
      class: _normalizeClass({
        'theme': _unref(theme),
        'row-header': _unref(theme)?.rowHeader,
        'row-footer': _unref(theme)?.rowFooter,
        'col-header': _unref(theme)?.colHeader,
        'col-footer': _unref(theme)?.colFooter,
      }),
      style: _normalizeStyle(`--themeColor: ${_unref(theme)?.color}; --subThemeColor1: ${_unref(subThemeColor)[0]}; --subThemeColor2: ${_unref(subThemeColor)[1]}`)
    }, [
      _createElementVNode("colgroup", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colSizeList.value, (width, index) => {
          return (_openBlock(), _createElementBlock("col", {
            span: "1",
            key: index,
            width: width
          }, null, 8, _hoisted_1))
        }), 128))
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (rowCells, rowIndex) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: rowIndex,
            style: _normalizeStyle({ height: __props.cellMinHeight + 'px' })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowCells, (cell, colIndex) => {
              return _withDirectives((_openBlock(), _createElementBlock("td", {
                class: "cell",
                style: _normalizeStyle({
              borderStyle: __props.outline.style,
              borderColor: __props.outline.color,
              borderWidth: __props.outline.width + 'px',
              ..._unref(getTextStyle)(cell.style),
            }),
                key: cell.id,
                rowspan: cell.rowspan,
                colspan: cell.colspan
              }, [
                _createElementVNode("div", {
                  class: "cell-text",
                  style: _normalizeStyle({ minHeight: (__props.cellMinHeight - 4) + 'px' }),
                  innerHTML: _unref(formatText)(cell.text)
                }, null, 12, _hoisted_3)
              ], 12, _hoisted_2)), [
                [_vShow, !_unref(hideCells).includes(`${rowIndex}_${colIndex}`)]
              ])
            }), 128))
          ], 4))
        }), 128))
      ])
    ], 6)
  ], 4))
}
}

})